<template>
  <start-page></start-page>
</template>

<script>
// @ is an alias to /src
import StartPage from "@/components/startPage.vue";

export default {
  name: "home",
  components: {
    StartPage
  },
  data: () => ({
    queryString: null
  }),
  created() {
    console.log("initPayPage");
    console.log(this.$store.state.route);
    this.$store.commit("STORE_CART", this.$store.state.route.query);
    // this.$store.commit("STORE_OPENER", window.opener);
    if (this.$store.state.route.query.paymentMethod == "p1") {
      this.$router.push("/card/");
    }

    if (this.$store.state.route.query.paymentMethod == "p2") {
      this.$router.push("/store/");
    }

    if (this.$store.state.route.query.paymentMethod == "p3") {
      this.$router.push("/npay/");
    }
    if (this.$store.state.route.query.paymentMethod == "p4") {
      this.$router.push("/payu/");
    }
    if (this.$store.state.route.query.paymentMethod == "p5") {
      this.$router.push("/paypal/");
    }
  }
};
</script>
